import { render, staticRenderFns } from "./DashboardReceiptTable.vue?vue&type=template&id=2887cf07&scoped=true&"
import script from "./DashboardReceiptTable.vue?vue&type=script&lang=js&"
export * from "./DashboardReceiptTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReceiptTable.vue?vue&type=style&index=0&id=2887cf07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887cf07",
  null
  
)

export default component.exports